/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateOrderStakeholderCommandResult } from '../../models/update-order-stakeholder-command-result';

export interface ApiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch$Params {
      body?: {
'Id'?: string;
'Name'?: string;
'StackholderId'?: number;
'UnitId'?: number;
}
}

export function apiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch$Params, context?: HttpContext): Observable<StrictHttpResponse<UpdateOrderStakeholderCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch.PATH, 'patch');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UpdateOrderStakeholderCommandResult>;
    })
  );
}

apiNurseryManagerOrderStakeholderUpdateOrderStakeholderPatch.PATH = '/api/NurseryManager/OrderStakeholder/UpdateOrderStakeholder';
